import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StepCartHeaderActionsProps {
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
}

export function StepCartHeaderActions({
  onCancel,
  onSave,
  isSaving = false,
}: StepCartHeaderActionsProps) {
  return (
    <div className="flex shrink-0 items-center gap-2">
      <Button variant="outline" onClick={onCancel}>
        Cancelar Proposta
      </Button>
      <Button
        className="bg-black text-white hover:bg-gray-800"
        onClick={onSave}
        disabled={isSaving}
      >
        {isSaving && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}
        {isSaving ? 'Salvando...' : 'Salvar'}
      </Button>
    </div>
  );
}

interface StepCartFooterActionsProps {
  onNextStep: () => void;
  isStepValid?: boolean;
  validationHint?: string | null;
  isSaving?: boolean;
}

export function StepCartFooterActions({
  onNextStep,
  isStepValid = true,
  validationHint,
  isSaving = false,
}: StepCartFooterActionsProps) {
  return (
    <div className="mt-6 flex flex-col items-end justify-end gap-3 border-t border-gray-200 pt-4 sm:flex-row sm:items-center">
      {!isStepValid && validationHint && (
        <span className="text-right text-xs text-amber-600">{validationHint}</span>
      )}
      <Button
        className="shrink-0 bg-black text-white hover:bg-gray-800"
        onClick={onNextStep}
        disabled={!isStepValid || isSaving}
      >
        {isSaving ? (
          <Loader2 className="mr-1 h-4 w-4 animate-spin" />
        ) : (
          <ArrowRight className="mr-1 h-4 w-4" />
        )}
        {isSaving ? 'Salvando...' : 'Próxima etapa'}
      </Button>
    </div>
  );
}
